import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { ContactDetailsForm } from './contact-details-form';

import { ContactData, ContactDataSchemaWithConstrains } from '@shared/types';
import { ViewEditDialog } from '@web/components/ui/view-edit-dialog';

type ContactDetailsCardProps = {
  contact?: ContactData;
  onSubmit: (data: ContactData) => Promise<void>;
  onClose?: () => void;
  newEntityCreation?: boolean;
};

export function ContactDetailsCard({
  contact,
  onSubmit,
  onClose,
  newEntityCreation = false,
}: ContactDetailsCardProps) {
  const defaultValues = contact ?? {
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'jane.doe@example.com',
    phoneNumber: '+1234567890',
  };

  const form = useForm<ContactData>({
    resolver: zodResolver(ContactDataSchemaWithConstrains),

    defaultValues,
  });

  return (
    <ViewEditDialog
      title="Contact Details"
      onSubmit={async () => {
        await form.trigger();
        await form.handleSubmit(onSubmit, (errors) => {
          throw Error(`invalid contact info ${JSON.stringify(errors)}`);
        })();
      }}
      onClose={onClose}
      initEditMode={true}
      newEntityCreation={newEntityCreation}
      render={({ isEditMode, setIsSubmitting }) => (
        <ContactDetailsForm
          form={form}
          isEditMode={isEditMode}
          setIsSubmitting={setIsSubmitting}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose?.();
          }}
        />
      )}
    />
  );
}
